import React from 'react';

import Dialog from 'material-ui/Dialog';
import './AccessDenied.css';

const styles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.85)'
  }
};

const AccessDenied = props => {
  return (
    <Dialog
      className="access-denied-dialog"
      overlayStyle={styles.overlay}
      actionsContainerStyle={styles.actions}
      title="Access Denied"
      modal={true}
      open={true}
    >
      <p>
        Your{' '}
        <a
          target="_blank"
          href="https://geoplatform.maps.arcgis.com"
          rel="noopener noreferrer"
        >
          GeoPlatform
        </a>{' '}
        account (<strong>{props.user.username}</strong>) is not authorized for
        IRWIN Observer.
      </p>

      <p>
        To request access, please{' '}
        <a
          href={`mailto:kara_stringer@ios.doi.gov?subject=Requesting Access To IRWIN Observer&body=${
            props.user.fullName
          }%0D%0A${props.user.username}`}
        >
          contact Kara Stringer
        </a>.
      </p>
    </Dialog>
  );
};

export default AccessDenied;



// WEBPACK FOOTER //
// ./src/components/AccessDenied.js